<template>
    <div :class="['header-menu', { 'is-active': isOpen }]">
        <ul class="header-menu__list">
            <li>
                <router-link to="/profile"
                             active-class="is-active"
                             class="mobile-menu__link">
                    <IconUser class-name="icon-stroke" />
                    {{ userName }}
                </router-link>
            </li>
            <li>
                <a href="#"
                   class="mobile-menu__link header-menu__logout"
                   @click.prevent="logoutUser">
                    <IconExit class-name="icon-stroke icon_color_label" />
                    Выйти
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {goOut} from '@/store/settings';
import IconExit from '@/components/Icons/Exit';
import IconUser from '@/components/Icons/User';

export default {
    name: 'PopupMenu',

    components: {
        IconExit,
        IconUser
    },

    data() {
        return {
            isOpen: false
        };
    },

    computed: {
        ...mapGetters({
            userName: 'GET_USER_NAME'
        }),
    },

    methods: {
        toggleMenu() {
            this.isOpen = !this.isOpen;
        },

        hideMenu() {
            if (!this.isOpen) {
                return;
            }

            this.isOpen = false;
        },

        /**
         * Выйти из аккаунта
         */
        logoutUser() {
            this.hideMenu();
            goOut();
        },
    }
};
</script>
